import script from "./TheTeam.vue?vue&type=script&setup=true&lang=js"
export * from "./TheTeam.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__